import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import CommonService from "../../services/common.service";
import { API_URLS } from "../../constants/api-urls";
import { unwrapApiData } from "./cm/cmProductionPaths";

/** Opens Shipping Manifest Create with PO / invoice / e-way from CM fulfillment. */
export default function SellerCmProductionShippingManifestPage() {
  const { rfqId } = useParams();
  const navigate = useNavigate();
  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        await CommonService.post(API_URLS.CONTRACT_MANUFACTURER.SELLER_FULFILLMENT_ENSURE_PO(rfqId), {});
        const res = await CommonService.get(API_URLS.CONTRACT_MANUFACTURER.SELLER_FULFILLMENT(rfqId));
        const data = unwrapApiData(res);
        const poId = data?.purchaseOrderId;
        const inv = data?.invoice;
        const eway = data?.ewayBill;
        if (!poId || !inv?.id) {
          throw new Error("Complete invoice and e-way steps before creating a shipping manifest.");
        }
        if (!cancelled) {
          navigate("/shipping-manifest-create", {
            replace: true,
            state: {
              poId,
              invoiceId: inv.id,
              invoiceNumber: inv.invoiceNumber,
              ewayBillId: eway?.id,
              ewayNumber: eway?.ewbNumber,
              cmRfqId: Number(rfqId),
            },
          });
        }
      } catch (e) {
        const m = e?.response?.data?.message || e?.message || "Failed to open manifest";
        toast.error(m);
        if (!cancelled) navigate("/seller/cm-rfqs", { replace: true });
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [rfqId, navigate]);

  return (
    <div className="container py-5">
      <p className="text-muted mb-0">Loading shipment context…</p>
    </div>
  );
}
